import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';

export default function About() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '桃子影院',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    description: '桃子影院是华语地区领先的免费在线电影观看平台，提供最新电影、热门电影排行榜、华语电影等海量高清影视资源。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-6666',
      contactType: 'customer service',
      email: 'contact@taozicinema.com',
      availableLanguage: ['Chinese'],
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
      streetAddress: '影视产业园',
    },
  };

  const breadcrumbLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: typeof window !== 'undefined' ? window.location.origin + '/' : '',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: typeof window !== 'undefined' ? window.location.href : '',
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 桃子影院"
        description="桃子影院是华语地区领先的免费在线电影观看平台，提供最新电影、热门电影排行榜、华语电影等海量高清影视资源。了解桃子影院的品牌故事、口碑评价和联系方式。"
        keywords="桃子影院,关于我们,品牌介绍,联系方式,免费电影平台"
        canonicalPath="/about"
        jsonLd={{ ...jsonLd, ...breadcrumbLd }}
      />

      <Navbar />

      <main className="pt-20">
        <Breadcrumb />

        {/* Brand Introduction */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
              <strong>关于桃子影院</strong>
            </h1>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              桃子影院成立于2020年，是华语地区领先的免费在线电影平台。我们致力于为每一位电影爱好者提供最新、最全、最流畅的高清观影体验。
            </p>
          </div>
        </section>

        {/* Brand Story */}
        <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-5">
              <strong>品牌故事</strong>
            </h2>
            <div className="prose-about">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                在数字娱乐蓬勃发展的时代，我们深知每一位影迷对优质观影体验的渴望。桃子影院的创始团队来自互联网和影视行业的资深从业者，怀揣着"让每个人都能免费看上好电影"的初心，精心打造了这个集电影大全、最新电影、热门电影排行榜于一体的综合性影视平台。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                我们的团队每天精心筛选和更新海量电影资源，从华语电影到欧美大片，从日韩精品到动画佳作，覆盖动作片、喜剧片、爱情片、科幻片、恐怖片等多种类型。无论是院线热映大片还是经典老片，您都能在桃子影院找到。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                我们采用先进的视频加速技术，确保影片秒开播放不缓冲。同时提供高清、超清、蓝光和4K多种画质选择，让每一位用户都能根据自己的设备和网络条件获得最佳的观影体验。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                桃子影院始终坚持"永久免费"的承诺，通过合理的广告收入维持平台运营，绝不向用户收取任何费用。我们相信，优质的电影内容应该属于每一个人。
              </p>
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="w-full px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6">
              <strong>用户口碑</strong>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
              {[
                {
                  name: '张先生',
                  text: '用了桃子影院快两年了，片源真的很全，更新也快。最重要的是真的不卡顿，4K画质非常清晰，强烈推荐！',
                  rating: 5,
                },
                {
                  name: '李女士',
                  text: '以前用过好多影视网站，不是收费就是广告太多。桃子影院真正做到了免费不卡顿，华语电影资源特别全。',
                  rating: 5,
                },
                {
                  name: '王同学',
                  text: '作为大学生，桃子影院真的是我的最爱。不用注册不用付费，打开就能看，画质还特别好，宿舍同学都在用。',
                  rating: 5,
                },
                {
                  name: '赵先生',
                  text: '电影分类很细，想找什么类型的电影都能快速找到。排行榜功能也很实用，好多好片都是从这里发现的。',
                  rating: 4,
                },
                {
                  name: '陈女士',
                  text: '带小孩一起看动画片，画质太棒了！而且加载速度超快，完全没有等待的烦恼。希望桃子影院越来越好！',
                  rating: 5,
                },
                {
                  name: '刘先生',
                  text: '蓝光4K画质太震撼了，在家就能享受影院级别的观影体验。永久免费这个承诺真的说到做到，良心平台。',
                  rating: 5,
                },
              ].map((review, index) => (
                <div key={index} className="p-4 md:p-5 rounded-lg bg-background-100">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                    "{review.text}"
                  </p>
                  <p className="text-xs font-medium text-foreground-800">{review.name}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6">
              <strong>联系我们</strong>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-primary-600 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-500">contact@taozicinema.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-accent-600 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">客服电话</h3>
                    <p className="text-sm text-foreground-500">400-888-6666</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-secondary-600 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">公司地址</h3>
                    <p className="text-sm text-foreground-500">北京市朝阳区影视产业园</p>
                  </div>
                </div>
              </div>

              <div className="p-4 md:p-5 rounded-lg bg-background-50 border border-background-200">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-3">工作时间</h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-foreground-500">周一至周五</span>
                    <span className="text-foreground-800">09:00 - 18:00</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-foreground-500">周六至周日</span>
                    <span className="text-foreground-800">10:00 - 16:00</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-foreground-500">法定节假日</span>
                    <span className="text-foreground-800">休息</span>
                  </div>
                </div>
                <p className="text-xs text-foreground-400 mt-4 leading-relaxed">
                  如果您有任何问题或建议，欢迎通过以上方式与我们联系。我们会在工作时间内尽快回复您的来信。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}